import TubeSwab from './TubeSwab'

export default TubeSwab
